import React, { useEffect, useRef, useState } from 'react';
import styled from 'styles/styled-components';
import media from 'utils/mediaStyle';
import {
  arrowNav,
  galleryImage1,
  galleryImage2,
  galleryImage3,
  galleryImage4,
  galleryImage5,
  galleryImage6,
  galleryImage7,
  galleryImage8,
  galleryImage9,
  galleryImage10,
  galleryImage11,
  galleryImage12,
  galleryImage13,
  galleryImage14,
  galleryImage15,
  galleryImage16,
  galleryImage17,
  galleryImage18,
  galleryImage19,
  galleryImage20,
  EyesIcon,
} from '../Images';

import { Viewport } from 'components/ViewportProvider';

import { Modal as AModal } from 'antd';
import SVGIcon from 'components/SVGIcon/SVGIcon';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Keyboard } from 'swiper/modules';
import { EventName, sendGA4Event } from 'utils/triggerGA4Event';
import { FormattedMessage } from 'react-intl';
import messages from '../messages';
import { commonDimensions } from 'utils/constants';

export const SectionContainer = styled.div`
  background: #ffffff;
  padding: 20px 0px;
  overflow: hidden;
  position: relative;
  ${media.lg`
    padding: 40px 0px;
    `}
  ${({ green }) =>
    green &&
    `
    background: #f0f9f1;
    `}
    ${({ gray }) =>
    gray &&
    `
    background: #fafafa;
    `}
  ${({ removePaddingBottom }) =>
    removePaddingBottom &&
    `
    padding-bottom: 0px !important;
    `}
    ${({ fullWidthAtHomePage }) =>
    fullWidthAtHomePage &&
    `
      margin: 0 -40px;
      @media(max-width: 991px) {
        margin: 0px;
      }
      `}
`;

export const Container = styled.div`
  max-width: ${commonDimensions.MAX_WIDTH_CONTAINER - 40}px;
  margin: 0 auto;
  padding: ${({ inner }) =>
      inner
        ? `
        20px 16px;`
        : `0px 16px;`}
    ${media.lg`
    padding: ${({ inner }) =>
      inner
        ? `
        40px 16px;`
        : `0px 16px;`}
    `};
  @media (min-width: ${commonDimensions.MAX_WIDTH_CONTAINER}px) {
    ${({ loggedIn }) =>
      loggedIn &&
      `
      padding-top: 40px;
    `}
  }
`;

export const SectionTitleBox = styled.div`
  width: 100%;
  margin-bottom: 24px;
  ${media.lg`
    margin-bottom: 40px;
    `}
`;

export const SectionTitle = styled.h3`
  display: inline;
  justify-content: center;
  font-size: 22px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  color: #242527;
  ${({ highLight }) =>
    highLight &&
    `
    color: #3C9041;
  `}
  ${media.lg`
    font-size: 40px;
    line-height: 48px;
    `}
  ${media.md`
    display: flex;
    font-size: 40px;
    line-height: 48px;
    `}
    ${({ initial }) =>
    initial &&
    `
      justify-content: flex-start;
    `}
  ${({ flex }) =>
    flex &&
    `
    display: inline;
  `}
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: auto auto;
  grid-gap: 8px;
  align-items: stretch;
  justify-items: center;
  ${media.md`
    grid-gap: 15px;
    `}
`;

const ImageItem = styled.div`
  transform: scale(1);
  transition: transform 0.3s ease;
  width: 100%;
  ${({ image }) => image && `background: url(${image});`}
  padding-top: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  ${({ large }) =>
    large &&
    `
    padding-top: 72% !important;
  `}
  ${media.md`
    padding-top: 72%;
    `}
  ${({ preview, isNotMobile }) =>
    preview &&
    `
    padding-top: 66% !important;
    @media(min-width: 1600px) {
      padding-top: 68% !important;
    }
  `}
`;

const ViewDetails = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: all 0.2s ease;
  pointer-events: none;
  color: #ffffff;
  z-index: 100;
  gap: 4px;
`;

const ViewMore = styled.div`
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%);
  ${media.md`
    font-size: 24px;
  `}
`;

const GridElement = styled.div`
  display: flex;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.8s ease;
  width: 100%;
  cursor: pointer;
  position: relative;

  ${({ large }) =>
    large &&
    `
      grid-column: span 4;
      grid-row: span 1;
    `}

  ${({ large, animate }) => {
    if (animate) {
      return `
        transform: translateX(0px);
        opacity: 1;
      `;
    }
    return `
        transform: translateX(${large ? '-50px' : '100px'});
        opacity: 0;
      `;
  }}

  &:hover {
    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(0deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%);
      pointer-events: none;
    }
    ${ImageItem} {
      transform: scale(1.1);
    }
    ${ViewDetails} {
      opacity: 1;
    }
    ${ViewMore} {
      display: none;
    }
  }

  ${media.md`
    ${({ large }) =>
      large &&
      `
        grid-column: span 2;
        grid-row: span 2;
      `}
  `}
`;

const Modal = styled(AModal)`
  background: unset;
  .ant-modal-content {
    background: transparent;
    box-shadow: unset;
    padding: 0;
    max-width: ${commonDimensions.MAX_WIDTH_CONTAINER}px;
    width: 100%;
    margin: 0 auto;
    .ant-modal-close {
      right: 0;
      color: #ffffff;
      top: -40px !important;
      padding: 8px !important;
      border-radius: 50% !important;
      &:hover {
        background: rgba(255, 255, 255, 0.15) !important;
      }
    }
    .ant-modal-body {
      border-radius: 8px;
      overflow: hidden;
      img {
        border-radius: 8px;
      }
    }
    ${media.md`
      max-width: 1000px;
      `}
  }
`;

const NavigationButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 40px;
  position: fixed;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  gap: 30px;
  z-index: 1051;
`;

const NavigationButton = styled.div`
  height: 44px;
  width: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 80px;
  cursor: pointer;
  background: #ffffff;
  &:hover {
    background: #f0f9f1 !important;
  }
  &:active {
    background: #d4edd5 !important;
  }
  ${({ disabled }) =>
    disabled &&
    `
    opacity: 0.8;
    cursor: initial;
  `}
  ${media.md`
    height: 56px;
    width: 56px;
    `}
`;

const NavigationButtonIcon = styled(SVGIcon)`
  color: #b6e1b9;
`;

const SlideNumber = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  color: #ffffff;
`;

const Partners = () => {
  const [visible, setVisible] = useState(false);
  const lang = localStorage.getItem('lang') || 'vi';
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isIntersecting, setIsIntersecting] = useState(false);
  const [swiperReady, setSwiperReady] = useState(false);
  const galleryRef = useRef(null);
  const swiperRef: any = useRef();

  const data = [
    { id: 1, img: galleryImage1 },
    { id: 2, img: galleryImage2 },
    { id: 3, img: galleryImage3 },
    { id: 4, img: galleryImage4 },
    { id: 5, img: galleryImage5 },
    { id: 6, img: galleryImage6 },
    { id: 7, img: galleryImage7 },
    { id: 8, img: galleryImage8 },
    { id: 9, img: galleryImage9 },
    { id: 10, img: galleryImage10 },
    { id: 11, img: galleryImage11 },
    { id: 12, img: galleryImage12 },
    { id: 13, img: galleryImage13 },
    { id: 14, img: galleryImage14 },
    { id: 15, img: galleryImage15 },
    { id: 16, img: galleryImage16 },
    { id: 17, img: galleryImage17 },
    { id: 18, img: galleryImage18 },
    { id: 19, img: galleryImage19 },
    { id: 20, img: galleryImage20 },
  ];

  const openPreview = (index) => {
    setCurrentIndex(index);
    setSwiperReady(true);
    setVisible(true);
    setTimeout(() => {
      if (swiperRef.current && swiperRef.current.slideToLoop) {
        swiperRef.current.init();
        swiperRef.current.slideToLoop(index, 0);
      }
    }, 100);
  };

  const goNext = () => {
    swiperRef.current.slideNext();
  };

  const goPrev = () => {
    swiperRef.current.slidePrev();
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsIntersecting(true);
        }
      },
      {
        threshold: 0.3,
      },
    );

    if (galleryRef.current) {
      observer.observe(galleryRef.current);
    }

    return () => {
      if (galleryRef.current) {
        observer.unobserve(galleryRef.current);
      }
    };
  }, []);
  return (
    <Viewport.Consumer>
      {({ width }) => {
        const isNotMobile = width > 767;
        return (
          <SectionContainer>
            <Container inner>
              <SectionTitleBox>
                {lang === 'vi' ? (
                  <>
                    <SectionTitle>Hình ảnh thực tế tại</SectionTitle>
                    <SectionTitle highLight>&nbsp;nông trại hợp tác Kamereo</SectionTitle>
                  </>
                ) : (
                  <>
                    <SectionTitle>Real images from</SectionTitle>
                    <SectionTitle highLight>&nbsp;Kamereo’s partner farms</SectionTitle>
                  </>
                )}
              </SectionTitleBox>
              <GridContainer ref={galleryRef}>
                {data.slice(0, 5).map((item, index) => (
                  <GridElement
                    key={item.id}
                    large={item.id === 1}
                    onClick={() => {
                      openPreview(index);
                      sendGA4Event(EventName.CLICK_FARM_IMAGE_FTB);
                    }}
                    animate={isIntersecting}
                  >
                    <ImageItem image={item.img} large={item.id === 1} />
                    <ViewDetails>
                      <SVGIcon src={EyesIcon} />
                      <FormattedMessage {...messages.viewDetail} />
                    </ViewDetails>
                    {index === 4 && <ViewMore>+{data.length - 5}</ViewMore>}
                  </GridElement>
                ))}
              </GridContainer>
              <Modal
                open={visible}
                footer={null}
                onCancel={() => {
                  setVisible(false);
                  setSwiperReady(false);
                }}
                centered
                width={isNotMobile ? '80%' : '90%'}
                bodyStyle={{ padding: 0, textAlign: 'center' }}
              >
                {swiperReady && (
                  <Swiper
                    onSwiper={(swiper) => {
                      swiperRef.current = swiper;
                    }}
                    slidesPerView={1}
                    spaceBetween={20}
                    modules={[Navigation, Keyboard]}
                    onSlideChange={(swiper) => {
                      setCurrentIndex(swiper.realIndex);
                    }}
                    loop={true}
                    init={false}
                    keyboard={{ enabled: true }}
                  >
                    {data.map((item, index) => (
                      <SwiperSlide key={index}>
                        <ImageItem preview image={item.img} isNotMobile={isNotMobile} />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                )}
              </Modal>
              {visible && (
                <NavigationButtonWrapper>
                  <NavigationButton onClick={goPrev}>
                    <NavigationButtonIcon src={arrowNav} style={{ transform: 'rotate(180deg)' }} />
                  </NavigationButton>
                  <SlideNumber>{`${currentIndex + 1}/${data.length}`}</SlideNumber>
                  <NavigationButton onClick={goNext}>
                    <NavigationButtonIcon src={arrowNav} />
                  </NavigationButton>
                </NavigationButtonWrapper>
              )}
            </Container>
          </SectionContainer>
        );
      }}
    </Viewport.Consumer>
  );
};

export default Partners;
